import React, {useState} from 'react';
import {Button, Form, Input} from 'antd';
import {SendOutlined} from '@ant-design/icons';
import {sanitize} from "../../../utils/html.utils";
import CommentService from "../../../services/comment/service";

const {TextArea} = Input;

const CommentForm = ({documentId, user, onSubmit}) => {
    const [form] = Form.useForm();
    const [submitting, setSubmitting] = useState(false);

    const handleFinish = async (values) => {
        setSubmitting(true);

        const data = {
            note: sanitize(values.comment),
        };

        await CommentService.AddComment({token: user.token, data, documentId});

        form.resetFields();
        setSubmitting(false);

        if (onSubmit) {
            onSubmit();
        }
    };

    return (
        <Form
            form={form}
            onFinish={handleFinish}
            style={{
                marginTop: 14,
                paddingTop: 14,
                borderTop: '1px solid #E4E7EE',
            }}
        >
            <div style={{display: 'flex', gap: 8, alignItems: 'flex-end'}}>
                <Form.Item
                    name="comment"
                    rules={[{required: true, message: 'Please enter your comment!'}]}
                    style={{flex: 1, marginBottom: 0}}
                >
                    <TextArea
                        autoSize={{minRows: 1, maxRows: 4}}
                        placeholder="Add a comment..."
                        style={{borderRadius: 8}}
                    />
                </Form.Item>
                <Button
                    htmlType="submit"
                    type="primary"
                    loading={submitting}
                    icon={<SendOutlined/>}
                >
                    Send
                </Button>
            </div>
        </Form>
    );
};

export default CommentForm;
